import LikeRepository from "../_repositories/likeRepository";
import {apiModelName, apiModelNameToDisplayName, clientModelName, toastSuccess} from "../_helpers/utils";
import {PrimaryModels} from "../_definitions/styleteq";
import {updateDataAction} from "./actions";
import * as _ from "lodash";
import UsersRepository from "../_repositories/userRepository";
import {shopByIdSelector, userByIdSelector} from "./selectors";
import {ResourceType} from "../_helpers/data";
import {currentUserSelector} from "../user/selectors";

export function toggleLike(model: PrimaryModels) {
    const resource = clientModelName(model);
    const likable = model as Likable;
    const like = !likable.isLiked;
    const count = like ? likable.likeCount + 1 : likable.likeCount - 1;

    return (dispatch, getState) => {
        dispatch(updateDataAction({
            id: model.id,
            resource: resource,
            data: _.chain(likable).cloneDeep().set('isLiked', like).set('likeCount', count).value()
        }));

        LikeRepository.toggle(model, currentUserSelector(getState())).then(() => {
            toastSuccess(`Successfully ${like ? '' : 'un'}liked ${apiModelNameToDisplayName(apiModelName(model))}.`);
        });
    }
}

export function toggleUserFollow(id: number, follower_id: number, is_followed: boolean) {
    return (dispatch, getState) => {
        const followed = userByIdSelector(getState(), id);
        const follower = userByIdSelector(getState(), follower_id);
        dispatch(updateDataAction({
            id: id,
            resource: ResourceType.user,
            data: _.chain(followed).cloneDeep()
                .set('isFollowed', !is_followed)
                .set('followersCount', !is_followed ? followed.followersCount + 1 : followed.followersCount - 1)
                .value()
        }));

        dispatch(updateDataAction({
            id: follower_id,
            resource: ResourceType.user,
            data: _.chain(follower).cloneDeep()
                .set('followingCount', !is_followed ? follower.followingCount + 1 : follower.followingCount - 1)
                .value()
        }));

        UsersRepository.toggleFollowUser(id, follower_id, is_followed).then(() => {
            toastSuccess(`You've ${is_followed ? 'un' : ''}followed this user.`)
        })
    }
}

export function toggleShopFollow(id: number, follower_id: number, is_followed: boolean) {
    return (dispatch, getState) => {
        const followed = shopByIdSelector(getState(), id);
        const follower = userByIdSelector(getState(), follower_id);
        dispatch(updateDataAction({
            id: id,
            resource: ResourceType.shop,
            data: _.chain(followed).cloneDeep()
                .set('isFollowed', !is_followed)
                .set('likeCount', !is_followed ? followed.likeCount + 1 : followed.likeCount - 1)
                .value()
        }));

        dispatch(updateDataAction({
            id: follower_id,
            resource: ResourceType.user,
            data: _.chain(follower).cloneDeep()
                .set('followingCount', !is_followed ? follower.followingCount + 1 : follower.followingCount - 1)
                .value()
        }));

        UsersRepository.toggleFollowShop(id, follower_id, is_followed).then(() => {
            toastSuccess(`You've ${is_followed ? 'un' : ''}followed this shop.`)
        })
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/middlewares.ts